import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Row,
  Spin,
  Upload,
  message,
  App,
  Table,
 Checkbox
} from "antd";
import { LeftOutlined, Loading3QuartersOutlined, LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { EDIT_LEARNER, VIEW_LEARNER,LIST_AZURE_CONFIG } from "../../apis/apis";
import { useNavigate, useParams } from "react-router-dom";
import LmsCountryDropdown from "../../components/LmsCountryDropdown";
import CulsightPageLoader from "../../components/CulsightPageLoader";
import {
  nameRegex,
  MAX_NAME_LENGTH,
  PINCODE_REGEX,
  PINCODE_LENGTH,
  MAX_ADDRESS_WORDS,
  getWordCount,
} from "../../../helper/CommonHelper";


export default function EditLearner() {
  const [firstNameError, setFirstNameError] = useState("");
const [lastNameError, setLastNameError] = useState("");
const [address1Error, setAddress1Error] = useState("");
const [address2Error, setAddress2Error] = useState("");
const [pinCodeError, setPinCodeError] = useState("");


const [azureList, setAzureList] = useState([]);
const [azureLoading, setAzureLoading] = useState(false);
const [showAzureCard, setShowAzureCard] = useState(false);
const [selectedAzure, setSelectedAzure] = useState(null);
const [searchDomain, setSearchDomain] = useState("");

  const { id } = useParams();
  const { notification } = App.useApp();
  const [page_loader, set_page_loader] = useState(true);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [image, set_image] = useState("");
  const [image_api, set_image_api] = useState("");

  const [organization, set_organization] = useState("");
  const [designation, set_designation] = useState("");
  const [first_name, set_first_name] = useState("");
  const [last_name, set_last_name] = useState("");
  const [email, setEmail] = useState("");
  const [country_code, set_country_code] = useState("IN");
  const [contact_no, set_contact_no] = useState("");
  const [address_line_1, set_address_line1] = useState("");
  const [address_line_2, set_address_line2] = useState("");
  const [pin_code, set_pin_code] = useState("");
  const [errors, set_errors] = useState("");
  const [imageError, setimageError] = useState("");



  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  };



  const uploadButton = (
    <button style={{ border: 0, background: "none",}} type="button">
      {loading ? <Loading3QuartersOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8.,}}>Upload</div>
    </button>
  );



  useEffect(() => {
    const VIEW_API = async () => {
      const FORM_DATA = new FormData();
      FORM_DATA.append("id", atob(id));
      const EDIT_API_RESPONSE = await VIEW_LEARNER(FORM_DATA);
      if (EDIT_API_RESPONSE?.data?.status) {
        const response_data = EDIT_API_RESPONSE?.data?.data;
        console.log(response_data);

        set_first_name(response_data?.first_name);
        if (response_data?.image) {
          set_image(response_data.image);
        } else {
          set_image("");
        }
        set_last_name(response_data?.last_name);
        setEmail(response_data?.email);
        set_contact_no(parseInt(response_data?.contact_no));
        set_organization(response_data?.organization);
        set_designation(response_data?.designation);
        set_country_code(response_data?.country_code);
        set_address_line1(response_data?.address_line_1);
        set_address_line2(response_data?.address_line_2);
        set_pin_code(response_data?.pin_code);
      setSelectedAzure(response_data?.meta?.azure_config_id? Number(response_data.meta.azure_config_id): null);
        set_page_loader(false);

      }
    };

    VIEW_API();
  }, [id]); 

 const onFinish = async () => {

  if (
    firstNameError ||
    lastNameError ||
    address1Error ||
    address2Error ||
    pinCodeError
  ) {
    message.error("Please fix validation errors");
    return;
  }

  setLoading(true);

  const FORM_DATA = new FormData();
  FORM_DATA.append("id", atob(id));
  FORM_DATA.append("first_name", first_name);
  FORM_DATA.append("last_name", last_name);
  FORM_DATA.append("country_code", country_code);
  FORM_DATA.append("contact_no", contact_no);
  FORM_DATA.append("address_line_1", address_line_1);
  FORM_DATA.append("address_line_2", address_line_2);
  FORM_DATA.append("organization", organization);
  FORM_DATA.append("designation", designation);
  FORM_DATA.append("pin_code", pin_code);
  FORM_DATA.append("image", image_api);
  FORM_DATA.append("azure_config_id", selectedAzure);

  try {
    const response = await EDIT_LEARNER(FORM_DATA);

    if (response?.data?.status) {
      notification.success({
        message: "Successful",
        description: response?.data?.message,
      });
      navigate("/learners");
    } else {
      setLoading(false);
      set_errors(response?.data?.errors);
    }
  } catch (error) {
    setLoading(false);
    message.error(
      "Server Error: " + (error?.response?.data?.message || "Unknown error")
    );
  }
};
  
// const azureColumns = [
//   {
//     title: "",
//     key: "select",
//     render: (_, record) => (
//       <Checkbox
//       checked={Number(selectedAzure) === Number(record.id)}
//         onChange={() => setSelectedAzure(record.id)}
//       />
//     ),
//     width: 60,
//   },
//   {
//     title: "Tenant ID",
//     dataIndex: "tenant_id",
//   },
//   {
//     title: "Client ID",
//     dataIndex: "client_id",
//   },
//   {
//     title: "Domain",
//     dataIndex: "domain",
//   },
// ];

  return (
    <div className="lms-body">
      <Card>
        <div className="lms-form">
        
          <Row>
            <Col span={12}>
              <h2><span       style={{ cursor: "pointer" }}
              onClick={() => navigate("/learners")} ><LeftOutlined /></span> Edit Learner</h2>
            </Col>
          </Row>
          {page_loader ? (
            <CulsightPageLoader />
          ) : (

            <Form
              form={form}
              layout="vertical"
              autoComplete="off"
              onFinish={onFinish}
              validateTrigger="onSubmit"
            >
              <h3>Basic Information</h3>

              <Form.Item label="Upload Your Photo here">
                <Upload
                  name="avatar"
                  listType="picture-card"
                  className="avatar-uploader"
                  showUploadList={false}
                   beforeUpload={(file) => {
                    console.log(file)
                    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/jpg";
                    const isLt2M = file.size <= 2 * 1024 * 1024;
                    if (!isJpgOrPng) {
                      setimageError("Only JPG/PNG files are allowed.");
                      return false;
                    }

                    if (!isLt2M) {
                      setimageError("Thumbnail must be smaller than or equal to 2MB.");
                      return false;
                    }
                    const img = new Image();
                    img.src = URL.createObjectURL(file);

                    img.onload = () => {
                      const { width, height } = img;
                      // Example: Minimum 600X400 pixels
                      if (width === 600 && height === 400) {
                            setimageError(""); // Clear errors if valid

                            // Set preview and file for API
                            getBase64(file, (url) => set_image(url));
                            set_image_api(file);
                           
                      } else {
                            setimageError("Image must be at least 600x400 pixels.");
                      }
                    
                    };
                      return false;
                  
                  }}
                 
                >
                  {image ? (
                    <img
                      src={image}
                      alt="avatar"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    uploadButton
                  )}
                </Upload>

                {/* Error message under the uploader */}
                {imageError && (
                  <span
                    style={{ color: "red", display: "block", marginTop: 8 }}
                  >
                    {imageError}
                  </span>
                )}
                {/* Server-side validation error */}
                {errors?.thumbnail && (
                  <span
                    style={{ color: "red", display: "block", marginTop: 8 }}
                  >
                    {errors?.thumbnail}
                  </span>
                )}

                 <p style={{ color: "#65e7c4", marginTop: "10px" }}>Note - Thumbnail must be smaller than or equal to 2MB and must be at least 600x400 pixels.</p>
              </Form.Item>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="First Name">
  <Input
    value={first_name}
    placeholder="Enter your First Name"
    showCount={{
      formatter: ({ count }) => `${count}/${MAX_NAME_LENGTH}`,
    }}
    onChange={(e) => {
      const value = e.target.value;
      set_first_name(value);

      if (!nameRegex.test(value)) {
        setFirstNameError("Only alphabets and spaces are allowed");
      } else if (value.length > MAX_NAME_LENGTH) {
        setFirstNameError(
          `First name cannot exceed ${MAX_NAME_LENGTH} characters`
        );
      } else {
        setFirstNameError("");
      }
    }}
  />

  {firstNameError && (
    <span style={{ color: "red" }}>{firstNameError}</span>
  )}

  {errors?.first_name && (
    <span style={{ color: "red" }}>{errors?.first_name}</span>
  )}
</Form.Item>

                </Col>
                <Col span={12}>
                  <Form.Item label="Last Name">
  <Input
    value={last_name}
    placeholder="Enter your Last Name"
    showCount={{
      formatter: ({ count }) => `${count}/${MAX_NAME_LENGTH}`,
    }}
    onChange={(e) => {
      const value = e.target.value;
      set_last_name(value);

      if (!nameRegex.test(value)) {
        setLastNameError("Only alphabets and spaces are allowed");
      } else if (value.length > MAX_NAME_LENGTH) {
        setLastNameError(
          `Last name cannot exceed ${MAX_NAME_LENGTH} characters`
        );
      } else {
        setLastNameError("");
      }
    }}
  />

  {lastNameError && (
    <span style={{ color: "red" }}>{lastNameError}</span>
  )}

  {errors?.last_name && (
    <span style={{ color: "red" }}>{errors?.last_name}</span>
  )}
</Form.Item>

                </Col>
                <Col span={12}>
                  <Form.Item label="Organization">
                    <Input
                      value={organization}
                      placeholder="Enter Organization"
                      onChange={(e) => set_organization(e.target.value)}
                    />
                    {errors?.organization ? (
                      <>
                        <span style={{ color: "red" }}>
                          {errors?.organization}
                        </span>
                      </>
                    ) : (
                      <></>
                    )}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Designation">
                    <Input
                      value={designation}
                      placeholder="Enter designation"
                      onChange={(e) => set_designation(e.target.value)}
                    />
                    {errors?.designation ? (
                      <>
                        <span style={{ color: "red" }}>
                          {errors?.designation}
                        </span>
                      </>
                    ) : (
                      <></>
                    )}
                  </Form.Item>
                </Col>
              </Row>

              <h3>Contact Information</h3>

              <Form.Item label="Email">
                <Input
                  type="email"
                  value={email}
                  placeholder="Enter learner email"
                  disabled
                  onChange={(e) => setEmail(e.target.value)}
                />
                {errors?.email && (
                  <span style={{ color: "red" }}>{errors?.email}</span>
                )}
              </Form.Item>

              <Form.Item label="Contact Number">
                <LmsCountryDropdown
                  country={country_code}
                  contact={contact_no}
                  set_country_code={set_country_code}
                  set_contact_no={set_contact_no}
                />
                {errors?.contact_no && (
                  <span style={{ color: "red" }}>{errors?.contact_no}</span>
                )}
              </Form.Item>

              <Row gutter={16}>
                <Col span={12}>
           <Form.Item label="Address 1">
  <Input
    value={address_line_1}
    placeholder="Enter your 1st address"
    showCount={{
      formatter: ({ count }) => `${count}/${MAX_ADDRESS_WORDS}`,
    }}
    onChange={(e) => {
      const value = e.target.value;
      set_address_line1(value);

      if (getWordCount(value) > MAX_ADDRESS_WORDS) {
        setAddress1Error(
          `Address 1 cannot exceed ${MAX_ADDRESS_WORDS} characters`
        );
      } else {
        setAddress1Error("");
      }
    }}
  />

  {address1Error && (
    <span style={{ color: "red" }}>{address1Error}</span>
  )}

  {errors?.address_line_1 && (
    <span style={{ color: "red" }}>{errors?.address_line_1}</span>
  )}
</Form.Item>



                </Col>
                <Col span={12}>
                <Form.Item label="Address 2">
  <Input
    value={address_line_2}
    placeholder="Enter your 2nd address"
    showCount={{
      formatter: ({ count }) => `${count}/${MAX_ADDRESS_WORDS}`,
    }}
    onChange={(e) => {
      const value = e.target.value;
      set_address_line2(value);

      if (getWordCount(value) > MAX_ADDRESS_WORDS) {
        setAddress2Error(
          `Address 2 cannot exceed ${MAX_ADDRESS_WORDS} characters`
        );
      } else {
        setAddress2Error("");
      }
    }}
  />

  {address2Error && (
    <span style={{ color: "red" }}>{address2Error}</span>
  )}

  {errors?.address_line_2 && (
    <span style={{ color: "red" }}>{errors?.address_line_2}</span>
  )}
</Form.Item>

                </Col>
              </Row>

             <Form.Item label="Pin Code">
  <Input
    value={pin_code}
    placeholder="Enter your pin code"
    showCount={{
      formatter: ({ count }) => `${count}/${PINCODE_LENGTH}`,
    }}
    onChange={(e) => {
      const value = e.target.value;

      if (!PINCODE_REGEX.test(value) && value !== "") {
        setPinCodeError("Only numbers are allowed");
        return;
      }

      if (value.length > PINCODE_LENGTH) {
        setPinCodeError(
          `Pin code cannot exceed ${PINCODE_LENGTH} digits`
        );
        return;
      }

      set_pin_code(value);
      setPinCodeError("");
    }}
  />

  {pinCodeError && (
    <span style={{ color: "red" }}>{pinCodeError}</span>
  )}

  {errors?.pin_code && (
    <span style={{ color: "red" }}>{errors?.pin_code}</span>
  )}
</Form.Item>

{/* <Form.Item>
  <Button
   type="primary"
    onClick={async () => {

      if (showAzureCard) {
        setShowAzureCard(false);
        return;
      }

      setShowAzureCard(true);

      if (azureList.length === 0) {
        setAzureLoading(true);
        try {
          const res = await LIST_AZURE_CONFIG();
          if (res?.data?.status) {
            setAzureList(res?.data?.data || []);
          }
        } catch {
          message.error("Failed to load Azure Config list");
        } finally {
          setAzureLoading(false);
        }
      }
    }}
  >
    {showAzureCard ? "Hide Tenant" : "Select Tenant"}
  </Button>
</Form.Item> */}

{/* {showAzureCard && (
  <Card
    title="Select Tanant"
    style={{ marginTop: 20 }}
  >
    <Input
      placeholder="Search by Domain"
      style={{ width: 300, marginBottom: 15 }}
      onChange={(e) => setSearchDomain(e.target.value)}
    />

    <Table
      columns={azureColumns}
      dataSource={azureList.filter((item) =>
        item.domain
          ?.toLowerCase()
          .includes(searchDomain.toLowerCase())
      )}
      rowKey="id"
      loading={azureLoading}
      bordered
       pagination={{
    pageSize: 5,              
    showSizeChanger: false,
       }}
     
    />
  </Card>
)} */}


              <Form.Item>
                {loading ? (
                  <Button type="primary" style={{ float: "right" }}>
                    Save{" "}
                    <Spin indicator={<LoadingOutlined spin />} size="small" />
                  </Button>
                ) : (
                  <Button
                    type="primary"
                    style={{ float: "right" }}
                    htmlType="submit"
                  >
                    Save
                  </Button>
                )}
              </Form.Item>

            </Form>
            
          )}
        </div>
      </Card>
    </div>
  );
}
